<script lang="ts" setup>
import { computed, inject } from 'vue'
import { useGotoBack } from '@/composables'

defineProps<{
  bookName?: string
  chapterName?: string
  isInShelf?: boolean
  shelfLoading?: boolean
}>()

const emit = defineEmits<{
  (e: 'click-book'): void
  (e: 'toggle-shelf'): void
}>()

const gotoBack = useGotoBack()
const theme = inject<any>('theme', { background: 'white' })

// 顶栏底色：与各阅读主题同色系但略有区分（不与正文背景完全一致）
const BAR_BG_MAP: Record<string, string> = {
  '#F6F7F9': '#FFFFFF',
  '#D5E9D4': '#E6F2E5',
  '#CEE7FF': '#E3F1FF',
  '#FFE1DC': '#FFEDE9',
  '#FBE6B5': '#FEF2D4',
  '#FDF2E8': '#FFF9F2',
  '#292929': '#1E1E1E',
}
const barBg = computed(() => {
  const bg = theme?.value?.background ?? theme?.background ?? '#FFFFFF'
  return BAR_BG_MAP[bg] ?? bg
})
</script>

<template>
  <div
    class="w-full h-48px flex items-center pl-8px pr-20px"
    :style="`background: ${barBg}`"
  >
    <!-- 返回 -->
    <div class="p-1 cursor-pointer" @click="gotoBack()">
      <i-icon-park-outline-left class="w-5 h-5 chapter-breadcrumb__primary-icon" />
    </div>

    <!-- 书名 + 章节号 -->
    <div class="flex-1 min-w-0 flex items-center text-14px font-bold lh-20px">
      <span
        class="truncate chapter-breadcrumb__secondary cursor-pointer max-w-50%"
        @click="emit('click-book')"
      >
        {{ bookName }}
      </span>
      <span class="truncate chapter-breadcrumb__primary ml-1 flex-1">
        /{{ chapterName }}
      </span>
    </div>

    <!-- 加入书架 -->
    <div
      class="ml-2 p-1 -mr-1 cursor-pointer flex items-center"
      :class="{ 'opacity-50 pointer-events-none': shelfLoading }"
      @click="emit('toggle-shelf')"
    >
      <i-assets-book-added-shelf
        v-if="isInShelf"
        class="w-22px h-22px chapter-breadcrumb__accent-icon"
      />
      <i-assets-book-add-shelf
        v-else
        class="w-22px h-22px chapter-breadcrumb__primary-icon"
      />
    </div>
  </div>
</template>

<style>
.chapter-breadcrumb__primary {
  color: var(--chapter-nav-primary, #32353A) !important;
}

.chapter-breadcrumb__secondary {
  color: var(--chapter-nav-secondary, #969CAA) !important;
}

.chapter-breadcrumb__primary-icon,
.chapter-breadcrumb__primary-icon * {
  color: var(--chapter-nav-primary, #32353A) !important;
}

.chapter-breadcrumb__accent-icon,
.chapter-breadcrumb__accent-icon * {
  color: var(--theme-radio-border, var(--primary-color)) !important;
}
</style>
